import ComisionCrud from './ComisionCrud'
export {ComisionCrud}
export default ComisionCrud
